<script>
	import { CodeEditor } from '@shopboxai/sb-portal-components';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
	export let origin;
	$: value = JSON.stringify(origin, null, 2);

	$: if (origin) {
		dispatch('change', origin);
	}
</script>

<div class="app-container">
	<CodeEditor bind:origin {value} />
</div>
